import React from "react";
import { CheckIcon } from "../../../../assets/Icons/CheckIcon";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { Button } from "../../../../shared/Button/Button";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";

export function ButtonSubmit({ isLoading, submit }) {
  var { tSurvey: t } = useAppTranslation.Survey();

  return (
    <Button
      isDisabled={isLoading}
      onClick={submit}
      leftAdornment={
        isLoading ? (
          <CircularProgress size="small" color="white" />
        ) : (
          <CheckIcon />
        )
      }
    >
      {t("submit")}
    </Button>
  );
}
